import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

const RoomCodes = memo((
  { room }) => {
  const { t } = useTranslation()
  const sortCodes = (codes) => {
    return codes.concat().sort((a, b) => {
      if (a.id < b.id) { return -1 }
      if (a.id > b.id) { return 1 }
      return 0
    })
  }
  const renderCode = (index, code) => {
    return <div key={index} className={'room-codes-code'} title={code.code}>
      <span className={'label'}>{code.id === 'pms' ? 'Hotelbeds' : code.id}: </span>
      {code.code}
    </div>
  }

  const renderDetail = (index, detail) => {
    return <React.Fragment key={index}>
      {sortCodes(detail.codes).map((code, key) => {
        return renderCode(key, code)
      })}
      {detail.label && renderCode(index + 'label', {
        id: t('LABEL'), code: detail.label
      })}
    </React.Fragment>
  }
  const renderRow = (index) => {
    const codesToRender = index === 0 && codes.length > 0 ? codes.length : 0
    const detail = details[index]

    return (
      <div key={index} className="room-codes-row">
        {codesToRender > 0 && (
          codes.map((code, index) => renderCode(index, code))
        )}
        {detail && renderDetail(index, detail)}
      </div>
    )
  }

  const codes = sortCodes(room.codes)
  const details = room.details
  const rowsToRender = Math.max(
    codes.length > 0 ? 1 : 0, details.length
  )
  if (rowsToRender === 0) {
    return <div className={'room-codes'}>
      <span className={'room-codes-no-codes'}>{t('NO_CODES')}</span>
    </div>
  }
  return (
    <div className={'room-codes'}>
      {Array.from({ length: rowsToRender }, (_, index) => renderRow(index))}
    </div>
  )
})

export default RoomCodes
